var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Environment } from '../../shared/environment/environment';
import { Cached } from '@ngx-cache/core';
import { CacheConstants } from '../../shared/cache-constants';
import { map } from 'rxjs/operators';
import { TvshopConstants } from '../../shared/tvshop-constants';
import { LanguageService } from '../language/language.service';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
var ResourceService = /** @class */ (function () {
    function ResourceService(httpClient, languageService) {
        this.httpClient = httpClient;
        this.languageService = languageService;
    }
    ResourceService.prototype.getColourForProduct = function (omapiId) {
        return this.getColoursForProducts()
            .pipe(map(function (packColors) {
            var colorFromFile = packColors.packcolors.find(function (color) {
                return color.omapiid === omapiId;
            });
            if (!colorFromFile) {
                return 'none';
            }
            return colorFromFile.color;
        }));
    };
    ResourceService.prototype.getColoursForProducts = function () {
        return this.httpClient
            .get(this.getBaseUrl() + '/telenet/data/product/colors');
    };
    ResourceService.prototype.getLogoUrl = function (packOmapiId, subPackOmapiId, isDaypass) {
        if (isDaypass) {
            var language = this.languageService.getCurrentLanguage();
            return Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(packOmapiId) + '-logo-' + language + '.png';
        }
        if (subPackOmapiId) {
            return Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(packOmapiId) + '-'
                + OmapiIdsUtils.getCorrectIdForResource(subPackOmapiId) + '-logo.png';
        }
        return Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(packOmapiId) + '-logo.png';
    };
    ResourceService.prototype.getBaseUrl = function () {
        return Environment.environmentConfig().baseUrl;
    };
    __decorate([
        Cached(CacheConstants.COLOR_FOR_PRODUCTS),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Observable)
    ], ResourceService.prototype, "getColoursForProducts", null);
    return ResourceService;
}());
export { ResourceService };
